import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron--thick-left",
  "use": "icon-chevron--thick-left-usage",
  "viewBox": "0 0 7 11",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 7 11\" id=\"icon-chevron--thick-left\"><path d=\"M1.626 6.121a1.02 1.02 0 0 1-1.347 0A.827.827 0 0 1 0 5.508c0-.222.093-.444.279-.613L5.357.27c.898-.818 2.245.408 1.347 1.226L1.626 6.121V4.895L6.704 9.52a.814.814 0 0 1 0 1.226 1.02 1.02 0 0 1-1.347 0L.28 6.121A.827.827 0 0 1 0 5.508c0-.222.093-.444.279-.613L5.357.27l1.347 1.226-5.078 4.625Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol